
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  formateTicketType,
  formateTicketIssueType,
  formateTicketStatus,
  ITicketsBtn,
  getBtnClass
} from '@/utils/tickets'
import { ORDERAPI } from '@/api/orders'
import { UserModule } from '@/store/modules/user'
import { TicketsModule } from '@/store/modules/tickets'
import { getRole, getuserCurrentApp, getuserWorkCode } from '@/utils/cookies'
import {
  isItTicketType,
  isLiveType,
  isNetworkTicketType,
  isAdministrationTicketType
} from '@/utils/commonFunc'
import { AppModule, DeviceType } from '@/store/modules/app'
import { platformV2 } from 'yach.open.jssdk'
import YachChat from '@/views/components/yachChat.vue'

@Component({
  name: 'TicketItem',
  components: {
    YachChat
  }
})
export default class extends Vue {
  @Prop({ default: () => null }) private ticket!: any;
  @Prop({ default: () => 0 }) private ticketIndex!: number;
  @Prop({ default: false }) private isManager!: boolean; // 是否为保障人员(处理)权限
  private isAcceptCurrentUser = this.setIsAcceptCurrentUser();
  private isCreateCurrentUser = this.setIsCreateCurrentUser();
  private ticketType = ''; // 工单类型
  private ticketStatus = {}; // 工单状态
  private btnObj: ITicketsBtn = {
    // 按钮是否显示
    edit: false,
    hurry: false,
    cancel: false,
    accept: false,
    reject: false,
    forward: false,
    finish: false,
    rate: false,
    close: false,
    className: 'fixed-full-btn', // 按钮样式名称
    isCompleted: false,
    pending: false,
    unpending: false
  };

  get currentWorkcode() {
    return getuserWorkCode()
  }

  // 角色
  get ROLE() {
    return Number(UserModule.roles || getRole() || 1)
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  get inYach() {
    return platformV2.inYach
  }

  // 受理人改变时，重新判断是否有操作按钮权限
  @Watch('ticket.accept_user.workcode')
  private onTicketStatusChange(value: number) {
    this.isAcceptCurrentUser = this.setIsAcceptCurrentUser()
    this.getBtnStatus()
  }

  // ticket改变时，重新判断是否有操作按钮权限
  @Watch('ticket')
  private onTicketChange(value: number) {
    this.getBtnStatus()
  }

  mounted() {
    this.$nextTick(() => {
      this.getBtnStatus()
    })
  }

  get isItTicketType() {
    return isItTicketType()
  }

  get isLiveType() {
    return isLiveType()
  }

  get isNetworkTicketType() {
    return isNetworkTicketType()
  }

  get isAdministrationTicketType() {
    return isAdministrationTicketType()
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  // 获取按钮显示及样式
  getBtnStatus() {
    this.btnObj = getBtnClass(
      this.ticket,
      this.isCreateCurrentUser,
      this.isAcceptCurrentUser,
      this.isManager ? 2 : 1
    )
  }

  // 工单类型
  private getTicketType(type: number) {
    this.ticketType = formateTicketType(type)
    return this.ticketType
  }

  // 工单问题类型
  private ticketIssueType(issueType: any) {
    return formateTicketIssueType(issueType)
  }

  // 工单状态
  private getTicketStatus(status: number, isForward: number) {
    const tStatus: any = formateTicketStatus(status, isForward)
    this.$set(this.ticketStatus, 'name', tStatus.name)
    this.$set(this.ticketStatus, 'class', tStatus.class)
    return this.ticketStatus
  }

  // 受理人 是否为当前用户
  private setIsAcceptCurrentUser() {
    const acceptUser = this.ticket.accept_user
      ? this.ticket.accept_user.account || ''
      : ''
    return acceptUser === UserModule.username
  }

  // 发起人 是否为当前用户
  private setIsCreateCurrentUser() {
    const creator = this.ticket.creator
      ? this.ticket.creator.account || ''
      : ''
    return creator === UserModule.username
  }

  // 查看详情
  private handleDetail(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'detailDialog',
      value: true
    })
  }

  // 编辑工单
  private handleEdit(ticket: any) {
    // if (ticket.ticket_type === 1) { // 主讲
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'editDialog',
      value: true
    })
    // } else { // 班主任
    //   TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    //   TicketsModule.ToggleDialogStatus({
    //     name: 'editTutorDialog',
    //     value: true
    //   })
    //   console.log(ticket.ticket_type)
    // }
  }

  // 撤销工单
  private handleCancel(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    this.$confirm(`确定要撤销「${ticket.tid}」此工单吗？`, '撤销确认', {
      type: 'warning',
      roundButton: true,
      customClass: 'confirm-center',
      cancelButtonClass: 'dilog-width-btn',
      confirmButtonClass: 'dilog-width-btn'
    })
      .then((_) => {
        ORDERAPI.cancelTicket({
          tid: ticket.tid,
          t_type: ticket.ticket_type
        })
          .then((res) => {
            this.handleSuccess(res)
          })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          .catch((_) => {})
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch((_) => {})
  }

  // 受理工单
  private handleAccept(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    this.$confirm(
      `确定要受理 ${ticket.creator.name} 发起的「${ticket.tid}」工单吗？`,
      '受理确认',
      {
        type: 'warning',
        roundButton: true,
        customClass: 'confirm-center',
        cancelButtonClass: 'dilog-width-btn',
        confirmButtonClass: 'dilog-width-btn'
      }
    )
      .then((_) => {
        ORDERAPI.acceptTicket(
          {
            tid: ticket.tid,
            t_type: ticket.ticket_type
          },
          {
            app_id: this.userCurrentApp
          }
        )
          .then((res) => {
            this.handleSuccess(res)
          })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          .catch(() => {})
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch((_) => {})
  }

  // 驳回工单
  private handleReject(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'rejectDialog',
      value: true
    })
  }

  // 完成工单
  private handleFinished(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'finishedDialog',
      value: true
    })
  }

  // 转接工单
  private handleForward(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'forwardDialog',
      value: true
    })
  }

  // 工单挂起
  private handlePending(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'pendingDialog',
      value: true
    })
  }

  // 工单挂起解除
  private handleUnPending(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'unpendingDialog',
      value: true
    })
  }

  private handleTagTicket(ticket: any) {
    const ticket_tag = ticket.tag === 1 ? 0 : 1
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    ORDERAPI.tagTicket({
      tid: ticket.tid,
      t_type: ticket.ticket_type,
      tag: ticket_tag
    }).then((res) => {
      this.handleSuccess(res)
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    }).catch(() => {
      console.log('ORDERAPI.tagTicket error ====>>>')
    })
  }

  // 催单
  private handleRemind(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    this.$confirm(`确定要催促「${ticket.tid}」此工单？`, '催单确认', {
      type: 'warning',
      roundButton: true,
      customClass: 'confirm-center',
      cancelButtonClass: 'dilog-width-btn',
      confirmButtonClass: 'dilog-width-btn'
    })
      .then((_) => {
        ORDERAPI.remindTicket({
          tid: ticket.tid,
          t_type: ticket.ticket_type
        })
          .then((res) => {
            this.$message({
              message: res.data,
              type: 'success'
            })
          })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          .catch(() => {})
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      .catch((_) => {})
  }

  // 评价工单
  private handleRate(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'rateDialog',
      value: true
    })
    // this.$router.push({ path: `/rate/${ticket.ticket_type}/${ticket.tid}` })
  }

  // 手动录入保障工单编辑
  private handleLiveManualEdit(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'editLiveDialog',
      value: true
    })
  }

  // 手动录入网络工单编辑
  private handleNetworkManualEdit(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'editNetworkDialog',
      value: true
    })
  }

  // 手动录入网络工单编辑
  private handleAdministrationManualEdit(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'editAdministrationDialog',
      value: true
    })
  }

  private handleSuccess(res: any) {
    if (res.stat) {
      this.$emit('handleSuccess', res)
    }
  }

  private clipboardSuccesssHandler() {
    (this as any).$toast('复制成功')
  }

  private clipboardErrorHandler() {
    (this as any).$toast('复制失败')
  }

  private handleYachChat(ticket: any) {
    (this.$refs.yachChat as any).onOpenSingleChat(ticket)
  }
}
